import Flickity from "flickity";
import flickityFade from "flickity-fade";
import eventBus from "./utils/eventBus";

function Slider(el) {
  el.classList.remove("hidden");
  const options = el.dataset?.options ? JSON.parse(el.dataset.options) : {};
  const indexEl = el.parentElement.querySelector("[data-index]");

  let flk = new Flickity(el, options);

  function prevSlide() {
    flk.previous();
    console.log("Prev slide");
  }

  function nextSlide() {
    flk.next();
    console.log("testslider");
  }

  const prev = document.querySelector(options.prevButton);
  if (prev) {
    prev.addEventListener("click", prevSlide);
  }
  const next = document.querySelector(options.nextButton);
  if (next) {
    next.addEventListener("click", nextSlide);
  }

  flk.on("change", (index) => {
    if (indexEl) indexEl.innerText = index + 1;
  });

  eventBus.on("slider-reinit", () => {
    // flk = new Flickity(el, options);
    flk.reposition();
    console.log("repo");
  });
}

export default Slider;
